import React, {useEffect, useState} from 'react';
import NewsList from "./components/NewsList";
import {collection, getDocs} from "firebase/firestore";
import {db, newsCollectionName, newsScheduledCollectionName} from "../../components/Firebase/Firebase";
import {useLoading} from "../../components/context/LoadingContext";
import './NewsPage.css'
import { CiSquarePlus } from 'react-icons/ci';
import {Button} from "@mui/material";
import {useNavigate} from "react-router-dom";

const NewsPage = () => {
    const [news, setNews] = useState([]);
    const [scheduledNews, setScheduledNews] = useState([]);
    const [isLoading, setIsLoading] = useLoading(false);
    const navigate = useNavigate();

    useEffect(() => {
        fetchNews();
    }, []);

    const fetchNews = async () => {
        try {
            setIsLoading(true);
            const publishedRef = collection(db, newsCollectionName);
            const scheduledRef = collection(db, newsScheduledCollectionName);

            const [pubSnap, schSnap] = await Promise.all([
                getDocs(publishedRef),
                getDocs(scheduledRef)
            ]);

            const newsList = pubSnap.docs
                .map(doc => ({ id: doc.id, ...doc.data() }))
                .sort((a, b) => new Date(b.date) - new Date(a.date));

            const scheduledList = schSnap.docs
                .map(doc => ({ id: doc.id, ...doc.data() }))
                .sort((a, b) => new Date(a.publishAt) - new Date(b.publishAt));

            setNews(newsList);
            setScheduledNews(scheduledList);
        } catch (error) {
            console.error(error);
        } finally {
            setIsLoading(false); 
        }
    };

    const handleCreateNews = () => {
        navigate(`/news/edit/new`, { state: { isNew: true } });
    };

    return (
        <div className='right-content'>
            <div className='card shadow border-0'>
                <div className="row d-flex align-items-center w-100">
                    <div className="col">
                        <h2 className='hd'>Новости</h2>
                    </div>
                    <div className="col d-flex justify-content-end">
                        <Button className="newObject" onClick={handleCreateNews}>
                            <CiSquarePlus />
                        </Button>
                    </div>
                </div>
                <div className='table-responsive mt-3'>
                    {scheduledNews.length > 0 && (
                        <>
                            <h4 className='hd'>Запланированные</h4>
                            <NewsList
                                news={scheduledNews}
                                onNewsUpdated={fetchNews}
                                collectionName={newsScheduledCollectionName}
                                dateFieldKey={'publishAt'}
                                editSource={'scheduled'}
                            />
                            <div style={{ height: 24 }} />
                        </>
                    )}
                    <h4 className='hd'>Опубликованные</h4>
                    <NewsList
                        news={news}
                        onNewsUpdated={fetchNews}
                        collectionName={newsCollectionName}
                        dateFieldKey={'date'}
                        editSource={'published'}
                    />
                </div>
            </div>
        </div>
    );
};

export default NewsPage;
